module.exports = "https://www.gc-qa.gnp.com.mx/b3a27b3c5bc9047a6fff2af04ab55627.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/auto1.png
// module id = 1798
// module chunks = 0